/**
 * GeoPolicyCtrl controller
 * Show general settings
 */

import { ACL_MODE_TYPES, GET_COUNTRIES } from 'app/core/constants'
import { toArray } from 'app/helpers/object'

// GeoPolicyCtrl mixins
GeoPolicyCtrl.mixes = [
  ['m2mCtrlMixin', 'configuration', 'blackList']
]

/**
 * GeoPolicyCtrl controller
 *
 * @class GeoPolicyCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:GeoPolicyCtrl
 */
/* @ngInject */
export default function GeoPolicyCtrl ($scope, $timeout, $uibModal, Acl, alertSvc) {
  var vm = this

  vm.tags = []

  GET_COUNTRIES().to(vm.countries = [])

  /**
   * Object with search strings
   *
   * @memberof mwApp/packages.controller:GeoPolicyCtrl
   * @type {models.Acl}
   */
  vm.acl = null

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Constant with mod types
   *
   * @type {Object}
   */
  vm.acl_mode_types = ACL_MODE_TYPES

  /**
   * Tag transformer for custom select value
   *
   * @param newTag
   * @return {{value : String}}
   */
  vm.tagTransform = function (newTag) {
    return {
      value: newTag
    }
  }

  /**
   * Default table params with default values
   *
   * @memberof mwApp/settings.controller:GeoPolicyCtrl
   * @type {Object}
   */
  vm.tableState = {
    pagination: {
      number: 100,
      start: 0,
      totalItemCount: 0
    },
    search: {},
    sort: {
      predicate: 'id',
      reverse: false
    }
  }

  /**
   * Load data acls
   */
  Acl.loadSmart(vm.tableState)
    .then(({ content }) => {
      vm.tableState.totalPages = content.totalPages
      return content || []
    })
    .to(vm.acls = [])
    .then((result) => {
      vm.acl = result[0]
      // TODO: hardcode
      vm.acl.geoOverrideIps = toArray('id', 'value')(vm.acl.geoOverrideIps)
      vm.acl.ipAddresses = toArray('id', 'value')(vm.acl.ipAddresses)
    })
    .then(() => { $scope.loading = false })

  /**
   * Save configuration acls
   *
   * @memberof mwApp/settings.controller:GeoPolicyCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vm.acl._save((acl) => {
      acl.geoOverrideIps = vm.acl.geoOverrideIps.map((o) => o.value)
      acl.ipAddresses = vm.acl.ipAddresses.map((o) => o.value)
    })
      .finally(vm.unsetDisable)
  }
}
